
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eula/ets",
      function () {
        return require("private-next-pages/eula/ets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eula/ets"])
      });
    }
  